(() => {
  const config = document.querySelector('[data-oe-wishlist-config]');
  const dialog = document.querySelector('[data-oe-wishlist-dialog]');
  if (!config || !dialog) return;

  const signedIn = config.dataset.loggedIn === 'true';
  const endpoint = config.dataset.endpoint;
  const status = document.querySelector('[data-oe-wishlist-status]');
  const pendingKey = 'oe-wishlist-pending-v1';
  const idPattern = /^[1-9]\d{0,19}$/;
  let saved = new Set();
  let lastTrigger = null;
  let loading = null;
  let statusTimeout;
  const busy = new Set();

  const announce = (message) => {
    status.textContent = '';
    status.hidden = false;
    requestAnimationFrame(() => { status.textContent = message; });
    clearTimeout(statusTimeout);
    statusTimeout = setTimeout(() => { status.hidden = true; }, 5000);
  };

  const sync = () => {
    document.querySelectorAll('[data-oe-wishlist-button]').forEach((button) => {
      const selected = saved.has(button.dataset.productId);
      const label = selected ? 'Von Wunschliste entfernen' : 'Zur Wunschliste hinzufügen';
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', label);
      button.title = label;
      button.disabled = busy.has(button.dataset.productId);
    });
  };

  const read = async () => {
    const response = await fetch(endpoint, {credentials: 'same-origin', headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error(`Wishlist read failed: ${response.status}`);
    const data = await response.json();
    if (!Array.isArray(data.items)) throw new Error('Invalid wishlist response');
    saved = new Set(data.items.map((item) => String(item.productId)).filter((id) => idPattern.test(id)));
    sync();
  };

  const load = () => {
    if (!loading) loading = read().then(() => true).catch(() => { loading = null; return false; });
    return loading;
  };

  const variantId = (button) => {
    if (!button.dataset.productPage) return button.dataset.variantId || null;
    const productInfo = button.closest('product-component')?.querySelector('product-info');
    const id = productInfo?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    if (idPattern.test(id || '')) return id;
    const urlId = new URLSearchParams(window.location.search).get('variant');
    return idPattern.test(urlId || '') ? urlId : null;
  };

  const change = async (productId, action, selectedVariantId = null) => {
    if (busy.has(productId)) return;
    busy.add(productId);
    const previouslySaved = saved.has(productId);
    if (action === 'add') saved.add(productId);
    else saved.delete(productId);
    sync();
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({action, productId, variantId: selectedVariantId}),
      });
      if (!response.ok) throw new Error(`Wishlist write failed: ${response.status}`);
      const result = await response.json();
      if (String(result.productId) !== productId || result.saved !== (action === 'add')) throw new Error('Invalid wishlist write response');
      document.dispatchEvent(new CustomEvent('oe:wishlist:changed', {detail: {productId, saved: action === 'add'}}));
      announce(action === 'add' ? 'Zur Wunschliste hinzugefügt' : 'Von der Wunschliste entfernt');
    } catch (_) {
      if (previouslySaved) saved.add(productId);
      else saved.delete(productId);
      announce('Das Speichern ist fehlgeschlagen. Bitte versuche es später erneut.');
    } finally {
      busy.delete(productId);
      sync();
    }
  };

  const showLogin = (button) => {
    lastTrigger = button;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('[data-oe-wishlist-close]')?.focus();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-oe-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const productId = button.dataset.productId;
    if (!idPattern.test(productId || '')) return;
    if (!signedIn) { showLogin(button); return; }
    load().then((ready) => {
      if (ready) change(productId, saved.has(productId) ? 'remove' : 'add', variantId(button));
      else announce('Die Wunschliste ist derzeit nicht verfügbar. Bitte versuche es später erneut.');
    });
  });

  dialog.querySelector('[data-oe-wishlist-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { lastTrigger?.focus(); });
  dialog.querySelector('[data-oe-wishlist-login]')?.addEventListener('click', () => {
    const productId = lastTrigger?.dataset.productId;
    if (!idPattern.test(productId || '')) return;
    try {
      sessionStorage.setItem(pendingKey, JSON.stringify({productId, variantId: variantId(lastTrigger), at: Date.now()}));
    } catch (_) { /* Login still works when storage is unavailable. */ }
  });

  if (signedIn) {
    load().then((ready) => {
      if (!ready) return;
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (_) { return; }
      if (!pending || !idPattern.test(pending.productId || '') || Date.now() - pending.at > 15 * 60 * 1000) {
        try { sessionStorage.removeItem(pendingKey); } catch (_) { /* no-op */ }
        return;
      }
      if (saved.has(pending.productId)) {
        sessionStorage.removeItem(pendingKey);
        return;
      }
      change(pending.productId, 'add', idPattern.test(pending.variantId || '') ? pending.variantId : null).then(() => {
        if (saved.has(pending.productId)) sessionStorage.removeItem(pendingKey);
      });
    });
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; sync(); });
    }).observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
  }
})();
